// NATIVE

// INSTALLED

// CUSTOM
import { checkingPreload, unCheckingPreload } from '../loading';
import { setApplicationsForSelect, setAppReleasesList, setAppRelease } from './appReleasesSlice';
import { QueryPagination } from '../../commons/interfaces';
import {
  deleteAppReleaseService,
  getApplicationDataDropDownService,
  getAppReleaseByIdService,
  getAllAppReleasesService,
  postAppReleaseService,
  putAppReleaseService,
  restoreAppReleaseService,
  markAsReadAppReleaseService,
} from '../../services/appReleases.service';

export const getApplicationDataDropDownStore = () => async (dispatch: any) => {
  dispatch(checkingPreload());
  try {
    const response = await getApplicationDataDropDownService();
    if (response.ok) {
      dispatch(setApplicationsForSelect(response.data));
    }
    return response;
  } catch (error) {
    console.error(error);
    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const getAppReleaseByIdStore = (id: string) => async (dispatch: any) => {
  dispatch(checkingPreload());
  try {
    const response = await getAppReleaseByIdService(id);
    if (response.ok) {
      dispatch(setAppRelease(response.data));
      dispatch(setApplicationsForSelect(response.data.applications));
    }
    return response;
  } catch (error) {
    console.error(error);
    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const getAllAppReleasesStore =
  (query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());
    try {
      const response = await getAllAppReleasesService(query);
      if (response.ok) {
        dispatch(setAppReleasesList(response.data));
      }
      return response;
    } catch (error) {
      console.error(error);
      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };

export const saveAppReleaseStore = (data: any) => async (dispatch: any) => {
  dispatch(checkingPreload());
  try {
    const response = await postAppReleaseService(data);
    if (response.ok) {
      dispatch(setAppReleasesList(response.data));
    }
    return response;
  } catch (error) {
    console.error(error);
    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const updateAppReleaseStore = (id: string, data: any) => async (dispatch: any) => {
  dispatch(checkingPreload());
  try {
    const response = await putAppReleaseService(id, data);
    return response;
  } catch (error) {
    console.error(error);
    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const deleteAppReleaseStore =
  (id: string, query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());
    try {
      const response = await deleteAppReleaseService(id, query);
      if (response.ok) {
        dispatch(setAppReleasesList(response.data));
      }
      return response;
    } catch (error) {
      console.error(error);
      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };

export const restoreAppReleaseStore =
  (id: string, query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());
    try {
      const response = await restoreAppReleaseService(id, query);
      if (response.ok) {
        dispatch(setAppReleasesList(response.data));
      }
      return response;
    } catch (error) {
      console.error(error);
      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };

export const markAsReadAppReleaseStore = (idNew: string) => async (dispatch: any) => {
  dispatch(checkingPreload());
  try {
    const response = await markAsReadAppReleaseService({ idNew });
    return response;
  } catch (error) {
    console.error(error);
    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};
